import React, { ReactNode } from 'react';
import { DefaultTheme } from 'styled-components';
import { Element } from './PaginateContainerDynamic.styles';

export interface PaginateContainerDynamicProps {
  readonly color?: keyof DefaultTheme['color'] & string;
  className?: string;
  children?: ReactNode;
}

const PaginateContainerDynamic = ({ children, ...props }: PaginateContainerDynamicProps) => {
  return <Element {...props}>{children}</Element>;
};

export default PaginateContainerDynamic;
